import { observer } from 'mobx-react-lite'
import * as Flags from 'country-flag-icons/react/3x2'
import classNames from 'classnames'
import { Alert, Typography } from 'shared/ui'
import { SelectField } from 'shared/ui/Select/SelectField/SelectField'
import { type Step3Store } from 'pages/register/ui/Register/ui/Step3/store/step3Store'
import styles from './styles.module.scss'

type IProps = {
  store: Step3Store
}

const Flag = ({ code }: { code: string }) => {
  const FlagComponent = (
    Flags as Record<string, React.ComponentType<React.SVGProps<SVGSVGElement>>>
  )[code]
  if (!FlagComponent) return null
  return <FlagComponent />
}

export const CountriesModalContent = observer(function CountriesModalContent({ store }: IProps) {
  const { allCountries, onSelectOtherCountry, selectedOtherCountry } = store

  const customAllCountries = allCountries.map((item) => ({
    ...item,
    labelContent: (
      <div className={styles.customCountry}>
        <Flag code={item.key} />
        <Typography variant={'body-md-regular'} ariaLabel={'selectedCountry'}>
          {item.label}
        </Typography>
      </div>
    ),
  }))

  return (
    <div className={classNames(styles.wrap, styles.modalContent)}>
      <Alert
        item={{
          type: 'infoBlue',
          title: 'Thank you for your interest in Salesmsg!',
          desc: 'Salesmsg is expanding to more countries soon. Let us know where you would like to use Salesmsg.',
        }}
      />
      <SelectField
        value={selectedOtherCountry?.key}
        items={customAllCountries}
        setValue={onSelectOtherCountry}
        selectProps={{
          dropdownProps: {
            margin: -36,
            withSearch: true,
            withTextInput: false,
            ariaLabel: 'Country',
          },
        }}
        btnProps={{
          text: selectedOtherCountry ? (
            <div className={styles.customCountry}>
              <Flag code={selectedOtherCountry.key} />
              <Typography variant={'body-md-regular'} ariaLabel={'selectedCountry'}>
                {selectedOtherCountry.label}
              </Typography>
            </div>
          ) : (
            'Select country'
          ),
        }}
      />
    </div>
  )
})
